import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    hideNotes: {
        id: "tasks.intervals.hideNotes",
    },
    createIntervalScoreTooltip: {
        id: "score.intervals.saveTooltip",
    },
});

export default messages;
